//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';
import { arrayObjectUniqSetKey } from '../utils/helper';

// Define the structure of a single dish
interface Dish {
  dishcategorycode?: any;
  dishid: number;
  dishname: string;
  // Add other fields as needed
}

// Define the state structure for dishes
interface DishesState {
  dishes: Dish[];
  loading: boolean;
  error: string | null;
}

// Initial state
const initialDishesState: DishesState = {
  dishes: [],
  loading: false,
  error: null,
};

// Updated fetchDishes function
export const fetchDishes = createAsyncThunk<Dish[], { userid: string | null; sitelistid?: number[] }>(
  'dishes/fetchDishes',
  async ({ userid, sitelistid }) => {
    const payload: { sitelistid?: number[]; userid: string } = {
      userid,
    };

    // Add sitelistid only if it has length
    if (sitelistid && sitelistid.length > 0) {
      payload.sitelistid = sitelistid;
    }

    const response = await axiosInstance.post<{ success: boolean; message: string; data: { dishes: Dish[] } }>(
      `${BASE_URL}/api/v1/Dish/GetDish`,
      payload
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data.dishes;
  }
);

// Create the slice
const dishesSlice = createSlice({
  name: 'dishes',
  initialState: initialDishesState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDishes.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on new fetch
      })
      .addCase(fetchDishes.fulfilled, (state, { payload }) => {
        state.loading = false;
        if(payload?.length!=0){
          state.dishes = arrayObjectUniqSetKey(payload,'dishid');
        }
      })
      .addCase(fetchDishes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch dishes';
      });
  },
});

export default dishesSlice.reducer;
